const state = {
  queryParams: {}
}

const mutations = {
  SET_QUERY_PARAMS (state, queryParams) {
    state.queryParams = queryParams
  },
  CLEAR_QUERY_PARAMS (state) {
    state.queryParams = {}
  }
}

const actions = {
  LOAD_QUERY_PARAMS (context, queryParams) {
    return context.commit('SET_QUERY_PARAMS', queryParams)
  }
}

const getters = {
  queryParams: state => state.queryParams
}

export const queryStringHelper = { state, mutations, actions, getters }
